import { render, staticRenderFns } from "./afterSaleOfGoods.vue?vue&type=template&id=5745632c&scoped=true&"
import script from "./afterSaleOfGoods.vue?vue&type=script&lang=js&"
export * from "./afterSaleOfGoods.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleOfGoods.vue?vue&type=style&index=0&id=5745632c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745632c",
  null
  
)

export default component.exports